import { render, staticRenderFns } from "./UsersPrivilegeEmployeesMoveSlides.vue?vue&type=template&id=15c1d8c8&scoped=true&"
import script from "./UsersPrivilegeEmployeesMoveSlides.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegeEmployeesMoveSlides.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c1d8c8",
  null
  
)

export default component.exports